import { Button, Center } from "@mantine/core";
import { modals } from "@mantine/modals";

import SRD_Form from "components/Form";
import React from "react";

import { useNavigate, useLocation } from "react-router-dom";
import { insertGroup } from "../apis/adminGroupApis";

function GroupAddForm() {
  const navigate = useNavigate();

  const fields = [
    {
      key: "group_nm",
      name: "그룹명",
      type: "text",
    },
  ];

  const location = useLocation();
  let backPage = 1;
  if (location.state) {
    backPage = location.state.pg;
  }

  const backToList = () => {
    const params = new URLSearchParams({page: String(backPage)});
    navigate(`/admin/group?${params.toString()}`, {replace: true});
  };

  const onSubmit = (e) => {
    modals.openConfirmModal({
      title: "저장",
      children: <Center>저장 하시겠습니까?</Center>,
    //  centered: true,
      zIndex: 2000,
      labels: { confirm: "저장", cancel: "취소" },
      onConfirm: () => {
        insertGroup(e);
        backToList();
      },
    });
  };

  const SubmitButton = () => {
    return (
      <Center style={{ marginTop: "1rem" }}>
        <Button type="submit">저장</Button>
      </Center>
    );
  };

  return (
    <SRD_Form
      fields={fields}
      onSubmit={onSubmit}
      submitButton={<SubmitButton />}
    />
  );
}

export default GroupAddForm;
